var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32576_351219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.609375,
    width: 30,
    height: 29.1973,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32576_351219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 24.9414L8.75 20.0752H3.75L4.375 17.6421H9.375L10.625 12.7759H5.625L6.25 10.3428H11.25L12.5 5.47656H15L13.75 10.3428H18.75L20 5.47656H22.5L21.25 10.3428H26.25L25.625 12.7759H20.625L19.375 17.6421H24.375L23.75 20.0752H18.75L17.5 24.9414H15L16.25 20.0752H11.25L10 24.9414H7.5ZM11.875 17.6421H16.875L18.125 12.7759H13.125L11.875 17.6421Z",
    fill: "#1F3864"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashIcon);
export default __webpack_public_path__ + "static/media/hash-icon.c913af1e9d07bbd67844707c2f5dbbec.svg";
export { ForwardRef as ReactComponent };